import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router';

// Import Style
import './Subscribe.scss';

class Subscribe extends Component {
  static defaultProps = {
    user: {},
  };

  constructor() {
    super();
  }

  render() {
    const remainingTrial = moment(this.props.user.trialEnd).diff(moment(), 'days') + 1;
    return (
      <div className='subscribe_box'>
        {this.props.user.trialExpired ? (
          <span>Your trial has expired</span>
        ) : this.props.user.cancelled ? (
          <span>Your subscription has ended</span>
        ) : (
          <span>
            Your trial expires in {remainingTrial} day
            {remainingTrial != 1 ? 's' : ''}
          </span>
        )}
        {this.props.user.status == 'trial' && (
          <Link to="/subscribe" className='btn btn-sm btn-red'>
            Upgrade
          </Link>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(Subscribe);
